import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  section: {
    marginBottom: theme.spacing(2)
  },

  propertiesHeader: {
    width: '100%',
    display: 'inline-flex',
    justifyContent: 'space-between',

    [theme.breakpoints.down('sm')]: {
      display: 'inline-flex',
      justifyContent: 'space-between',
      flexDirection: 'column',
      alignItems: 'flex-start'
    }
  },

  infoContainerContent: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: '16px',
    padding: '0 16px',
    marginBottom: '16px'
  },

  selectedAnimalsContainer: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    marginTop: 8,

    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      justifyContent: 'center',
      gap: 8
    }
  },
  selectedAnimalsCount: {
    fontSize: 14,
    color: theme.palette.primary.main,
    fontWeight: 500,
    marginRight: 16
  },

  checkInputContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 32,

    [theme.breakpoints.down('xs')]: {
      gap: 8,
      flexDirection: 'column'
    }
  },

  infoContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',

    '& span:first-child': {
      fontWeight: 500,
      color: '#000'
    },

    '& span:last-child': {
      fontWeight: 400,
      color: '#000'
    }
  },

  weightingImageContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '16px'
  },

  inputWithEditToggle: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',

    '&:hover .editToggleButton': {
      opacity: 1
    }
  },

  helperTextContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,

    '& p': {
      margin: 0,
      fontSize: 14,
      fontWeight: 400,
      color: '#000'
    }
  },

  // Estilos específicos para informações do animal
  animalInfoHeader: {
    flex: 1,
    width: '100%'
  },

  animalOperationIndicator: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    marginBottom: '20px',
    '@media (max-width: 768px)': {
      marginBottom: '16px'
    }
  },

  animalOperationIconContainer: {
    width: 48,
    height: 48,
    borderRadius: 12,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.3s ease',
    backgroundColor: 'rgba(76, 175, 80, 0.125)',
    '@media (max-width: 768px)': {
      width: 40,
      height: 40
    }
  },

  animalOperationIcon: {
    fontSize: '24px',
    color: '#4caf50',
    '@media (max-width: 768px)': {
      fontSize: '20px'
    }
  },

  animalOperationInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px'
  },

  animalModalTitle: {
    margin: 0,
    color: '#1a1a1a',
    fontSize: '1.5rem',
    fontWeight: 600,
    lineHeight: 1.2,
    '@media (max-width: 768px)': {
      fontSize: '1.25rem'
    }
  },

  animalOperationDescription: {
    margin: 0,
    color: '#666',
    fontSize: '0.9rem',
    lineHeight: 1.4,
    '@media (max-width: 768px)': {
      fontSize: '0.85rem'
    }
  },

  animalRecordDetails: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    width: '100%',
    '@media (max-width: 768px)': {
      gap: '16px'
    }
  },

  animalRecordInfoRow: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
    gap: '20px',
    width: '100%',
    '@media (max-width: 768px)': {
      gridTemplateColumns: '1fr',
      gap: '16px'
    },
    '@media (max-width: 480px)': {
      gap: '12px'
    }
  },

  animalRecordInfoItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '20px',
    backgroundColor: '#ffffff',
    borderRadius: '12px',
    border: '1px solid #e2e8f0',
    boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
    transition: 'all 0.2s ease',
    minHeight: '70px',
    '&:hover': {
      boxShadow: '0 3px 8px 0 rgba(0, 0, 0, 0.15)',
      transform: 'translateY(-2px)',
      borderColor: '#d1d5db'
    },
    '@media (max-width: 768px)': {
      padding: '16px',
      minHeight: '60px'
    },
    '@media (max-width: 480px)': {
      padding: '12px',
      minHeight: '50px'
    }
  },

  animalInfoIcon: {
    fontSize: '20px',
    color: '#4a5568',
    flexShrink: 0,
    '@media (max-width: 768px)': {
      fontSize: '18px'
    },
    '& path': {
      fill: '#4a5568'
    }
  },

  animalInfoContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    flex: 1
  },

  animalInfoLabel: {
    fontSize: '0.75rem',
    color: '#718096',
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    lineHeight: 1.2,
    '@media (max-width: 768px)': {
      fontSize: '0.7rem'
    }
  },

  animalInfoValue: {
    fontSize: '1rem',
    color: '#2d3748',
    fontWeight: 500,
    lineHeight: 1.3,
    wordBreak: 'break-word',
    '@media (max-width: 768px)': {
      fontSize: '0.9rem'
    }
  },

  formActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '16px',
    marginTop: '24px',

    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
      gap: '12px'
    }
  },

  buttonWrapper: {
    width: 'fit-content !important',

    [theme.breakpoints.down('xs')]: {
      width: '100% !important'
    }
  }
}))
